export function supportedTimezones(currentTimezone?: string): string[] {
	const timezones =
		typeof Intl.supportedValuesOf === 'function'
			? Intl.supportedValuesOf('timeZone')
			: ['Europe/London'];
	const unique = new Set(['UTC', ...timezones]);
	if (currentTimezone) unique.add(currentTimezone);
	return [
		'UTC',
		...Array.from(unique)
			.filter((timezone) => timezone !== 'UTC')
			.sort((left, right) => left.localeCompare(right)),
	];
}
